const NotFound = () => (
  <section className="page notfound-page">
    <h1>404</h1>
    <p>We could not find that page.</p>
  </section>
)

export default NotFound
